export default __webpack_public_path__ + "static/media/kids.8651bf81.svg";